export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        badge: {
            variant: "info",
            text: "menuitems.dashboards.badge"
        },
        subItems: [
            {
                id: 4,
                label: "menuitems.dashboards.list.saas",
                link: "/dashboard/saas",
                parentId: 2
            },
            {
                id: 5,
                label: "Saas 2",
                link: "/dashboard/crypto",
                parentId: 2
            },
            {
                id: 6,
                label: "menuitems.dashboards.list.blog",
                link: "/dashboard/blog",
                parentId: 2
            }
        ]
    },
    {
        id: 7,
        isLayout: true
    },
    {
        id: 8,
        label: "menuitems.apps.text",
        isTitle: true
    },
    {
        id: 9,
        label: "menuitems.calendar.text",
        icon: "bx-calendar",
        link: "/calendar"
    },
    {
        id: 10,
        label: "menuitems.chat.text",
        icon: "bx-chat",
        link: "/chat",
    },
    {
        id: 11,
        label: "menuitems.filemanager.text",
        link: "/apps/file-manager",
        icon: "bx-file",
        badge: {
            variant: "success",
            text: "menuitems.chat.badge"
        }
    },
    {
        id: 34,
        label: "menuitems.invoices.text",
        icon: "bx-receipt",
        subItems: [
            {
                id: 35,
                label: "menuitems.invoices.list.invoicelist",
                link: "/invoices/list",
                parentId: 34
            },
            {
                id: 36,
                label: "menuitems.invoices.list.invoicedetail",
                link: "/invoices/detail",
                parentId: 34
            }
        ]
    },
    {
        id: 37,
        label: "menuitems.projects.text",
        icon: "bx-briefcase-alt-2",
        subItems: [
            {
                id: 38,
                label: "menuitems.projects.list.grid",
                link: "/projects/grid",
                parentId: 37
            },
            {
                id: 39,
                label: "menuitems.projects.list.projectlist",
                link: "/projects/list",
                parentId: 37
            },
            {
                id: 40,
                label: "menuitems.projects.list.overview",
                link: "/projects/overview",
                parentId: 37
            },
            {
                id: 41,
                label: "menuitems.projects.list.create",
                link: "/projects/create",
                parentId: 37
            }
        ]
    },
    {
        id: 42,
        label: "menuitems.tasks.text",
        icon: "bx-task",
        subItems: [
            {
                id: 43,
                label: "menuitems.tasks.list.tasklist",
                link: "/tasks/list",
                parentId: 42
            },
            {
                id: 44,
                label: "menuitems.tasks.list.kanban",
                link: "/tasks/kanban",
                parentId: 42
            },
            {
                id: 45,
                label: "menuitems.tasks.list.createtask",
                link: "/tasks/create",
                parentId: 42
            }
        ]
    },
    {
        id: 46,
        label: "menuitems.contacts.text",
        icon: "bxs-user-detail",
        subItems: [
            {
                id: 47,
                label: "menuitems.contacts.list.usergrid",
                link: "/contacts/grid",
                parentId: 46
            },
            {
                id: 48,
                label: "menuitems.contacts.list.userlist",
                link: "/contacts/list",
                parentId: 46
            },
            {
                id: 49,
                label: "menuitems.contacts.list.profile",
                link: "/contacts/profile",
                parentId: 46
            }
        ]
    },
    {
        id: 50, 
        label: "menuitems.blog.text",
        icon: "bx-detail",
        badge: {
            variant: "success",
            text: "menuitems.blog.badge"
        },
        subItems: [
            {
                id: 51,
                label: 'menuitems.blog.list.bloglist',
                link: '/blog/list',
                parentId: 50
            },
            {
                id: 52,
                label: 'menuitems.blog.list.grid',
                link: '/blog/grid',
                parentId: 50
            },
            {
                id: 53,
                label: 'menuitems.blog.list.detail',
                link: '/blog/detail',
                parentId: 50
            }
        ]
    },
    {
        id: 78,
        label: "menuitems.components.text",
        isTitle: true
    },
    {
        id: 108,
        icon: "bx-list-ul",
        label: "menuitems.tables.text",
        subItems: [
            {
                id: 109,
                label: "menuitems.tables.list.basic",
                link: "/tables/basic",
                parentId: 108
            },
            {
                id: 110,
                label: "menuitems.tables.list.advanced",
                link: "/tables/advanced",
                parentId: 108
            }
        ]
    },
    {
        id: 111,
        icon: "bxs-bar-chart-alt-2",
        label: "menuitems.charts.text",
        subItems: [
            {
                id: 112,
                label: "menuitems.charts.list.apex",
                link: "/charts/apex",
                parentId: 111
            },
            {
                id: 113,
                label: "menuitems.charts.list.chartjs",
                link: "/charts/chartjs",
                parentId: 111
            },
            {
                id: 114,
                label: "menuitems.charts.list.chartist",
                link: "/charts/chartist",
                parentId: 111
            },
            {
                id: 115,
                label: "menuitems.charts.list.echart",
                link: "/charts/echart",
                parentId: 111
            }
        ]
    },
    {
        id: 121,
        label: "menuitems.maps.text",
        icon: "bx-map",
        subItems: [
            {
                id: 122,
                label: "menuitems.maps.list.googlemap",
                link: "/maps/google",
                parentId: 121
            },
            {
                id: 123,
                label: "menuitems.maps.list.leafletmap",
                link: "/maps/leaflet",
                parentId: 121
            },
        ]
    }
];

